module.exports = {
	"Заполните название вашей компании": "Заполните название вашей компании",
	"Заполните ваше имя и фамилию": "Заполните ваше имя и фамилию",
	"Телефон должен начинаться с \"+\" и кода страны": "Телефон должен начинаться с «+» и кода страны",
	"Телефон должен быть в международном формате и содержать 12 цифр": "Телефон должен быть в международном формате и содержать 12 цифр",
	"Неправильный имейл": "Неправильная эл. почта",
	"Пароль должен сожержать не меньше 8 символов": "Пароль должен состоять минимум из 8 символов",
	"Текст об интеграции должен быть не меньше двух предложений (100 символов)": "Текст об интеграции должен быть не меньше двух предложений (100 символов)",
	"Неправильный номер телефона. Попробуйте ввести номер в международном формате.": "Неправильный номер телефона. Попробуйте ввести номер в международном формате."
};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/ru/site.json
// module id = 265
// module chunks = 1